// DESIGN-SPEC §5.13 FaqAccordion 折叠问答
"use client";

import { cn } from "@/lib/cn";

export interface FaqItem {
  question: string;
  answer: string;
}

export function FaqAccordion({
  items,
  className,
}: {
  items: FaqItem[];
  className?: string;
}) {
  return (
    <div className={cn("border-t border-line", className)}>
      {items.map((item) => (
        <details key={item.question} className="group border-b border-line">
          <summary className="flex min-h-13 cursor-pointer list-none items-center justify-between gap-4 py-3 text-sm leading-[21px] font-semibold text-ink focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest-500 [&::-webkit-details-marker]:hidden">
            {item.question}
            <span
              aria-hidden="true"
              className="relative size-5 shrink-0 transition-transform duration-[120ms] group-open:rotate-45 before:absolute before:top-1/2 before:left-1/2 before:h-px before:w-3.5 before:-translate-x-1/2 before:-translate-y-1/2 before:bg-forest-700 before:content-[''] after:absolute after:top-1/2 after:left-1/2 after:h-3.5 after:w-px after:-translate-x-1/2 after:-translate-y-1/2 after:bg-forest-700 after:content-['']"
            />
          </summary>
          <p className="pb-4 pr-8 text-sm leading-[21px] text-ink-2">
            {item.answer}
          </p>
        </details>
      ))}
    </div>
  );
}
